import { CAMPAIGNS_TABLE_COLUMNS } from '../components/table'

export const campaignsDataPreparation = ({ data, combos, intl }) => {
  if (!Array.isArray(data)) {
    return []
  }

  return data.map((item) => {
    if (!item || typeof item !== 'object') {
      return {
        id: null,
        activa: false,
        is_removable: false,
      }
    }

    const formattedDates = {}
    const formattedText = {}
    CAMPAIGNS_TABLE_COLUMNS.forEach((column) => {
      if (column.type === 'date' && item[column.field]) {
        formattedDates[column.field] = intl.formatDate(item[column.field])
      }
      if (column.multiple && Array.isArray(item[column.field]) && item[column.field].length > 0) {
        const itemValues = item[column.field].map(({ nombre }) => nombre)
        formattedText[column.field] = itemValues.join(', ')
      }

      // Manejo especial para financiación
      if (column.field === 'financiacion') {
        if (item.financiacion) {
          formattedText[column.field] = item.meses_financiacion ? `${item.meses_financiacion} meses` : 'No'
        } else {
          formattedText[column.field] = 'No'
        }
      }

      if (!item[column.field] && column.field !== 'activa' && column.field !== 'actions' && column.field !== 'financiacion') {
        const fieldsWithNo = ['descuento', 'ingreso']
        if (fieldsWithNo.includes(column.field)) {
          formattedText[column.field] = 'No'
        }
      }
    })

    return {
      ...item,
      ...formattedDates,
      ...formattedText,
      activa: item.activa ?? false,
      is_removable: item.is_removable ?? false,
      id: item.id ?? null,
      tableData: {
        ...item.tableData,
      },
    }
  })
}
